import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import { wizardStepAtom } from '../recoil/atoms/wizardAtom';
import { pageIndex, type WizardPageComponentName, wizardPages } from '../config/wizardPagesConfig';
import { useCallback } from 'react';
import { trackWizardNavigation } from '../utils/trackingUtil';
import { isSavingPackageAtom } from '../recoil/atoms/isSavingPackageAtom';
import { refreshCoveragePackagesAtom } from '../recoil/atoms/refreshCoveragePackagesAtom';

const useWizardNavigation = (): {
    wizardStep: number;
    wizardNextStep: () => void;
    wizardPreviousStep: () => void;
    wizardGotoStep: (name: WizardPageComponentName | undefined) => void;
} => {
    const [wizardStep, setWizardStep] = useRecoilState(wizardStepAtom);
    const refreshPackages = useSetRecoilState(refreshCoveragePackagesAtom);
    const resetIsSavingPackage = useResetRecoilState(isSavingPackageAtom);

    const wizardNextStep = useCallback((): void => {
        if (wizardStep < wizardPages.length) {
            trackWizardNavigation(wizardPages[wizardStep].name);
            setWizardStep(wizardStep + 1);
        }
    }, [setWizardStep, wizardStep]);
    const wizardPreviousStep = useCallback((): void => {
        if (wizardStep > 1) {
            trackWizardNavigation(wizardPages[wizardStep].name);
            setWizardStep(wizardStep - 1);
        }
    }, [setWizardStep, wizardStep]);

    const wizardGotoStep = useCallback(
        (name: WizardPageComponentName | undefined): void => {
            if (!name) return;
            if (name === 'CoveragePackagePage') {
                resetIsSavingPackage();
                refreshPackages({});
            }
            trackWizardNavigation(name);
            setWizardStep(pageIndex(name));
        },
        [refreshPackages, resetIsSavingPackage, setWizardStep]
    );

    return { wizardStep, wizardNextStep, wizardPreviousStep, wizardGotoStep };
};

export default useWizardNavigation;
